module.exports = {"main":[{"text":"Новости кампании","link":"https://bahna.land/ru/search?q=%D0%9540"},{"text":"e40stop@gmail.com","link":"mailto:e40stop@gmail.com"}],"social":[{"text":"Facebook","link":"https://www.facebook.com/hashtag/stop_e40?source=feed_text&story_id=1786471531643899"},{"text":"Twitter","link":"https://twitter.com/search?src=typd&q=%23stop_e40"},{"text":"Instagram","link":"https://www.instagram.com/explore/tags/stop_e40/"},{"text":"Vkontatke","link":"https://vk.com/bahna.land"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/footer.ru.json
// module id = 163
// module chunks = 0